import { SvgIcon } from '@mui/material';
import React from 'react';

import activity from '%/images/activity.svg';
import add from '%/images/add.svg';
import alert from '%/images/alert.svg';
import arrowDown from '%/images/arrow-down.svg';
import arrow from '%/images/arrow.svg';
import bellRing from '%/images/bell-ring.svg';
import browser from '%/images/browser.svg';
import check from '%/images/check.svg';
import circles from '%/images/circles.svg';
import circles_logo_light from '%/images/circles_light.svg';
import closeOutline from '%/images/close-outline.svg';
import close from '%/images/close.svg';
import connections from '%/images/connections.svg';
import crossInCircle from '%/images/cross-in-circle.svg';
import edit from '%/images/edit.svg';
import exclamation_and_question_mark from '%/images/exclamation_and_question_mark.svg';
import facebook from '%/images/facebook.svg';
import follow from '%/images/follow.svg';
import friends from '%/images/friends.svg';
import heart_with_exclamation_mark from '%/images/heart_with_exclamation_mark.svg';
import mail from '%/images/mail.svg';
import megaphone from '%/images/megaphone.svg';
import members from '%/images/members.svg';
import menu from '%/images/menu.svg';
import more from '%/images/more.svg';
import noSearchResult from '%/images/no-search-result.svg';
import notification from '%/images/notification.svg';
import offline from '%/images/offline.svg';
import okTick from '%/images/ok-tick.svg';
import partySuccess from '%/images/party-success.svg';
import plus from '%/images/plus.svg';
import qrLarge from '%/images/qr-large.svg';
import qr from '%/images/qr.svg';
import refresh from '%/images/refresh.svg';
import reload from '%/images/reload.svg';
import scan from '%/images/scan.svg';
import search from '%/images/search.svg';
import send from '%/images/send.svg';
import share from '%/images/share.svg';
import telegram from '%/images/telegram.svg';
import transactions from '%/images/transactions.svg';
import triangleWarning from '%/images/triangle-warning.svg';
import trustActive from '%/images/trust-active.svg';
import trustMutual from '%/images/trust-mutual.svg';
import trust from '%/images/trust.svg';
import trustedDirectly from '%/images/trusted-directly.svg';
import twitter from '%/images/twitter.svg';
import union from '%/images/union.svg';
import uploadPhoto from '%/images/upload-photo.svg';
import wobblyCircleSecond from '%/images/wobbly-circle-second.svg';
import wobblyCircle from '%/images/wobbly-circle.svg';
import world from '%/images/world.svg';

export const IconActivity = (props) => {
  return <SvgIcon component={activity} {...props} viewBox="0 0 24 24" />;
};

export const IconAdd = (props) => {
  return <SvgIcon component={add} {...props} viewBox="0 0 20 20" />;
};

export const IconAlert = (props) => {
  return <SvgIcon component={alert} {...props} viewBox="0 0 18 21" />;
};

export const IconArrowDown = (props) => {
  return <SvgIcon component={arrowDown} {...props} viewBox="0 0 14 14" />;
};

export const IconBack = (props) => {
  return <SvgIcon component={arrow} {...props} viewBox="0 0 25 25" />;
};

export const IconBrowser = (props) => {
  return <SvgIcon component={browser} {...props} viewBox="0 0 25 25" />;
};

export const IconBellRing = (props) => {
  return <SvgIcon component={bellRing} {...props} viewBox="0 0 25 25" />;
};

export const IconCheck = (props) => {
  return <SvgIcon component={check} viewBox="0 0 512 512" {...props} />;
};

export const IconCircles = (props) => {
  return <SvgIcon component={circles} viewBox="0 0 24 34" {...props} />;
};

export const IconCirclesLogoLight = (props) => {
  return (
    <SvgIcon component={circles_logo_light} {...props} viewBox="0 0 32 32" />
  );
};

export const IconClose = (props) => {
  return <SvgIcon component={close} {...props} viewBox="0 0 25 25" />;
};

export const IconCloseOutline = (props) => {
  return <SvgIcon component={closeOutline} {...props} viewBox="0 0 20 20" />;
};

export const IconCrossInCircle = (props) => {
  return <SvgIcon component={crossInCircle} {...props} viewBox="0 0 20 20" />;
};

export const IconConnections = (props) => {
  return <SvgIcon component={connections} {...props} viewBox="0 0 24 16" />;
};

export const IconExclamationAndQuestionMark = (props) => {
  return (
    <SvgIcon
      component={exclamation_and_question_mark}
      {...props}
      viewBox="0 0 32 25"
    />
  );
};

export const IconFacebook = (props) => {
  return <SvgIcon component={facebook} {...props} viewBox="0 0 11 20" />;
};

export const IconEdit = (props) => {
  return <SvgIcon component={edit} {...props} viewBox="0 0 30 30" />;
};

export const IconFollow = (props) => {
  return <SvgIcon component={follow} {...props} viewBox="0 0 24 24" />;
};

export const IconFriends = (props) => {
  return <SvgIcon component={friends} {...props} viewBox="0 0 12 12" />;
};

export const IconHeartWithExclamationMark = (props) => {
  return (
    <SvgIcon
      component={heart_with_exclamation_mark}
      {...props}
      viewBox="0 0 29 33"
    />
  );
};

export const IconMail = (props) => {
  return <SvgIcon component={mail} {...props} viewBox="0 0 21 18" />;
};

export const IconMegaphone = (props) => {
  return <SvgIcon component={megaphone} {...props} viewBox="0 0 23 23" />;
};

export const IconMembers = (props) => {
  return <SvgIcon component={members} {...props} viewBox="0 0 32 35" />;
};

export const IconMenu = (props) => {
  return <SvgIcon component={menu} {...props} viewBox="0 0 24 25" />;
};

export const IconMore = (props) => {
  return <SvgIcon component={more} {...props} viewBox="0 0 25 25" />;
};

export const IconNoSearchResult = (props) => {
  return (
    <SvgIcon component={noSearchResult} {...props} viewBox="0 0 151 148" />
  );
};

export const IconNotification = (props) => {
  return <SvgIcon component={notification} {...props} viewBox="0 0 24 27" />;
};

export const IconOffline = (props) => {
  return <SvgIcon component={offline} {...props} viewBox="0 0 25 25" />;
};

export const IconOkTick = (props) => {
  return <SvgIcon component={okTick} {...props} viewBox="0 0 24 24" />;
};

export const IconPartySuccess = (props) => {
  return <SvgIcon component={partySuccess} {...props} viewBox="0 0 25 25" />;
};

export const IconPlus = (props) => {
  return <SvgIcon component={plus} {...props} viewBox="0 0 20 20" />;
};

export const IconRefresh = (props) => {
  return <SvgIcon component={refresh} {...props} viewBox="0 0 25 25" />;
};

export const IconReload = (props) => {
  return <SvgIcon component={reload} {...props} viewBox="0 0 25 25" />;
};

export const IconQR = (props) => {
  return <SvgIcon component={qr} viewBox="0 0 18 18" {...props} />;
};

export const IconQRLarge = (props) => {
  return <SvgIcon component={qrLarge} viewBox="0 0 36 36" {...props} />;
};

export const IconScan = (props) => {
  return <SvgIcon component={scan} {...props} viewBox="0 0 25 25" />;
};

export const IconSearch = (props) => {
  return <SvgIcon component={search} {...props} viewBox="0 0 23 22" />;
};

export const IconSend = (props) => {
  return <SvgIcon component={send} {...props} viewBox="0 0 36 36" />;
};

export const IconShare = (props) => {
  return <SvgIcon component={share} {...props} viewBox="0 0 25 25" />;
};

export const IconTelegram = (props) => {
  return <SvgIcon component={telegram} {...props} viewBox="0 0 21 20" />;
};

export const IconTransactions = (props) => {
  return <SvgIcon component={transactions} {...props} viewBox="0 0 19 24" />;
};

export const IconTriangleWarning = (props) => {
  return <SvgIcon component={triangleWarning} {...props} viewBox="0 0 24 24" />;
};

export const IconTrust = (props) => {
  return <SvgIcon component={trust} {...props} viewBox="0 0 30 38" />;
};

export const IconTrustActive = (props) => {
  return <SvgIcon component={trustActive} {...props} viewBox="0 0 32 38" />;
};

export const IconTrustedDirectly = (props) => {
  return <SvgIcon component={trustedDirectly} {...props} viewBox="0 0 24 24" />;
};

export const IconTrustMutual = (props) => {
  return <SvgIcon component={trustMutual} {...props} viewBox="0 0 29 34" />;
};

export const IconTwitter = (props) => {
  return <SvgIcon component={twitter} {...props} viewBox="0 0 21 18" />;
};

export const IconUploadPhoto = (props) => {
  return <SvgIcon component={uploadPhoto} {...props} viewBox="0 0 64 34" />;
};

export const IconUnion = (props) => {
  return <SvgIcon component={union} {...props} viewBox="0 0 15 13" />;
};

export const IconWobblyCircle = (props) => {
  return <SvgIcon component={wobblyCircle} {...props} viewBox="0 0 55 55" />;
};

// Hacky solution to be able to use this same icon twice in the same view with a different styling behavior
export const IconWobblyCircleSecond = (props) => {
  return (
    <SvgIcon component={wobblyCircleSecond} {...props} viewBox="0 0 55 55" />
  );
};

export const IconWorld = (props) => {
  return <SvgIcon component={world} {...props} viewBox="0 0 24 24" />;
};

export const iconSelector = (icon) => {
  switch (icon) {
    case 'IconActivity':
      return IconActivity;
    case 'IconAdd':
      return IconAdd;
    case 'IconAlert':
      return IconAlert;
    case 'IconArrowDown':
      return IconArrowDown;
    case 'IconBack':
      return IconBack;
    case 'IconBrowser':
      return IconBrowser;
    case 'IconBellRing':
      return IconBellRing;
    case 'IconCheck':
      return IconCheck;
    case 'IconCircles':
      return IconCircles;
    case 'IconClose':
      return IconClose;
    case 'IconCloseOutline':
      return IconCloseOutline;
    case 'IconConnections':
      return IconConnections;
    case 'IconCrossInCircle':
      return IconCrossInCircle;
    case 'IconFacebook':
      return IconFacebook;
    case 'IconEdit':
      return IconEdit;
    case 'IconFollow':
      return IconFollow;
    case 'IconFriends':
      return IconFriends;
    case 'IconMail':
      return IconMail;
    case 'IconMembers':
      return IconMembers;
    case 'IconMenu':
      return IconMenu;
    case 'IconNoSearchResult':
      return IconNoSearchResult;
    case 'IconNotification':
      return IconNotification;
    case 'IconOffline':
      return IconOffline;
    case 'IconOkTick':
      return IconOkTick;
    case 'IconPartySuccess':
      return IconPartySuccess;
    case 'IconPlus':
      return IconPlus;
    case 'IconRefresh':
      return IconRefresh;
    case 'IconQR':
      return IconQR;
    case 'IconQRLarge':
      return IconQRLarge;
    case 'IconReload':
      return IconReload;
    case 'IconScan':
      return IconScan;
    case 'IconSearch':
      return IconSearch;
    case 'IconSend':
      return IconSend;
    case 'IconShare':
      return IconShare;
    case 'IconTelegram':
      return IconTelegram;
    case 'IconTransactions':
      return IconTransactions;
    case 'IconTriangleWarning':
      return IconTriangleWarning;
    case 'IconTrustActive':
      return IconTrustActive;
    case 'IconTrustedDirectly':
      return IconTrustedDirectly;
    case 'IconTrustMutual':
      return IconTrustMutual;
    case 'IconTwitter':
      return IconTwitter;
    case 'IconUnion':
      return IconUnion;
    case 'IconUploadPhoto':
      return IconUploadPhoto;
    case 'IconWobblyCircle':
      return IconWobblyCircle;
    case 'IconWobblyCircleSecond':
      return IconWobblyCircleSecond;
    case 'IconWorld':
      return IconWorld;
    default:
      return IconAlert;
  }
};
